// CANONICAL COPY (GH #7115). src/constants/obligations/obl-policy-review.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-policy-review',
  title: 'Review information security policy',
  description:
    'Perform the scheduled review of the information security policy. Verify it remains aligned with business objectives, regulatory requirements, and the current threat landscape.',
  category: 'governance',
  scfIds: ['SCF-GOV-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-within-sla', description: 'Policy document review is not overdue' },
    { type: 'document-approved', description: 'Policy was re-approved after latest review' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
